module.exports = __webpack_public_path__ + "resources/default_4.f43c6a7e33224f46.png";


//////////////////
// WEBPACK FOOTER
// ../src/component/post-welfare-v2/img/default_4.png
// module id = 766
// module chunks = 0 2